import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { Session } from '@models/Session';
import { User } from '@models/User';
import { UserService } from '@services/user.service';
// import { DetailPageService } from '@services/support/detail-page.service';
// import { SessionDetailsComponent } from './session-details/session-details.component';
import { Room } from '@models/Room';
// import { AccountService } from '@services/account.service';

import { saveAs } from "file-saver";

import { environment } from "../../../../../environments/environment";
import { RoomService } from '@services/remote/room.service';
import { SessionService } from '@services/remote/session.service';
import { UtilityService } from '@services/remote/utility.service';
import { AuthService } from '@services/auth.service';
import { WorkflowService } from '@services/workflow.service';
import { Router } from '@angular/router';
import { DetailPageService } from '@services/detail-page.service';
import { SessionDetailsComponent } from '../sessions/session-details/session-details.component';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { UserListModalComponent } from 'src/app/components/modals/user-list-modal/user-list-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-session-list',
    templateUrl: './session-list.component.html',
    styleUrls: ['./session-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SessionListComponent implements OnInit, OnDestroy {

  @ViewChild(MatSort, { static: false })
  set sort(sorter: MatSort) {
    this.dataSource.sort = sorter;
  }

  @ViewChild(MatPaginator, { static: false })
  set paginator(paginator: MatPaginator) {
    this.dataSource.paginator = paginator;
    setTimeout(() => {
        // this.pageIndex = this.dataSource.paginator.pageIndex
        // this.pageSize = this.dataSource.paginator.pageSize
    },10000);
  }
  dataSource = new MatTableDataSource<Session>();
  displayedColumns: string[] = [
    "index",
    "room",
    "create_time",
    "duration",
    "participants",
    "status",
    "export"
  ];

  sessions: Session[] = null;
  allSessions: Session[] = null;
  sessionSub: Subscription = null;

  users: User[] = [];
  userSub: Subscription = null;

  rooms: Room[] = [];
  roomsSub: Subscription = null;

  page: number = 1;
  offset: number = 30;
  pageCount: number = 1;

  filterStartEnd: Date[] = [];
  currentStart: Date;
  currentEnd: Date;
  filterUsers: string[] = [];
  filterRooms: string[] = [];

  sessionStats: any = null;

  accountDataSub: Subscription = null;
  timezone: string = "UTC";
  differenceBetweenTimezones: number = 0;
  isFilterAvailable = true
  isLoading: boolean = false;
  hasFullRoomAccess = false;

  sessionDetailOpen = false
  pageIndex: number;
  pageSize: number;

  private sessionsUpdate$ = new Subject<Session[]>();
  private sessionsUpdateSub: Subscription = null;
  private filterRoomsSnapshot: string[] = [];
  private filterUsersSnapshot: string[] = [];

  constructor(
    // private accountService: AccountService,
    private userService: UserService,
    private roomService: RoomService,
    private sessionService: SessionService,
    private detailPageService: DetailPageService,
    private utilityService: UtilityService,
    private workflowService: WorkflowService,
    private authService: AuthService,
    private router: Router,
    private modalService: BsModalService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    // this.accountDataSub = this.accountService.accountData.subscribe(accountData => {
    //   this.timezone = accountData.timezone;
    //   this.filterSessions(this.timezone);
    // });

    // Debounced session processing — Firebase child_added fires per-session
    this.sessionsUpdateSub = this.sessionsUpdate$.pipe(debounceTime(300)).subscribe(sessions => {
      this.isLoading = false;
      const rooms = this.filterRoomsSnapshot;
      const users = this.filterUsersSnapshot;

      this.allSessions = sessions.filter(session => {
        let roomSelected = rooms.length > 0 ? rooms.includes(session.room_id) : true;
        let userSelected = users.length > 0 ? users.some(id => (session.users ? Object.keys(session.users) : []).includes(id)) : true;
        return roomSelected && userSelected;
      });

      this.calculateStats(this.allSessions)
        .then(stats => { this.sessionStats = stats });

      this.pageCount = Math.ceil(this.allSessions.length / this.offset);
      this.sessions = this.allSessions.slice((this.page - 1) * this.offset, this.page * this.offset);

      this.allSessions.forEach(session => {
        if (session['participants']) return;
        let participants = [];

        if (session.users) {
          participants = this.getIds(session.users);
          participants = this.getUserNames(participants);
        }

        if (session['guest_users']) {
          const guestParticipants = Object.values(session['guest_users']).map(user => ({
            name: user['name'],
            isGuest: true
          }));
          participants = [...participants, ...guestParticipants];
        }
        session['participants'] = participants;
      });

      this.dataSource = new MatTableDataSource(this.allSessions);
      this.setupSorting(this.dataSource);
    });
    
    this.workflowService.getUsers().then(res => {
      this.users = res.users
        .map(u => {
          const user = JSON.parse(JSON.stringify(u))
          if (user.disabled) {
            user.disabledUser = true
            delete user.disabled
          }
          return user
        })
        .filter(u => !u.deleted)
        .sort((a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase()));
      
      // Call filterSessions after users are loaded
      this.filterSessions('UTC');
    });

    this.hasFullRoomAccess = this.roomService.hasFullRoomAccess();
    if (this.hasFullRoomAccess) {
      this.roomsSub = this.roomService.allRooms.subscribe(r => {
        this.rooms = r.map(room => {
          room.name = room.room_data.name;
          return room;
        })
        .sort((a, b) => {
          if(a.name && b.name) {
            return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase())
          }else{
            return 0
          }
        });
      });
    } else {
      this.roomsSub = this.authService.user.subscribe(user => {
        this.rooms = ((user && user.rooms) ? Object.keys(user.rooms).map(roomId => ({
          id: roomId,
          name: user.rooms[roomId].name,
          room_data: {
            ...user.rooms[roomId],
            name: user.rooms[roomId].name,
            users: user.rooms[roomId].users || {}
          }
        } as Room)) : [])
        .sort((a, b) => {
          if (a.name && b.name) {
            return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase())
          } else {
            return 0
          }
        });
      });
    }
  }

  async filterSessions(timezone: string) {
    const offset = await this.utilityService.getServerTimeOffset();

    const currentTimeInBrowserTimezone = new Date().getTime();
    const currentTimeInAccountTimezone = new Date(Date.now() + offset + UtilityService.timezoneOffset + UtilityService.timezones[timezone]).getTime();

    this.differenceBetweenTimezones = currentTimeInAccountTimezone - currentTimeInBrowserTimezone;
    
    const todayTimestampOffsetAdded = currentTimeInAccountTimezone;
    const oneWeekAgoTimestamp = 604800000; //equals to 7 days
    const oneWeekDifference = todayTimestampOffsetAdded - oneWeekAgoTimestamp;

    const oneWeekAgo = this.setSessionDateFilterValues(new Date(oneWeekDifference), 0, 0, 0, 0);
    const today = this.setSessionDateFilterValues(new Date(todayTimestampOffsetAdded), 23, 59, 59, 59);
    this.filterStartEnd = [oneWeekAgo, today];
  
    this.applyFilters();
  }

  setSessionDateFilterValues(date: Date, ...time) {
    date.setHours(time[0]);
    date.setMinutes(time[1]);
    date.setSeconds(time[2]);
    date.setMilliseconds(time[3]);

    return date;
  }

  onSessionExport() {
    let exportText = "\uFEFF" + this.translateService.instant('MAIN.SESSIONS.SESSION_LIST.EXPORT_HEADER') + "\n";
    for (const s of this.allSessions) {
      let sessionText = this.formatDate(s.create_time) + ",";
      sessionText = sessionText + this.getRoomName(s.room_id) + ",";
      sessionText = sessionText + '"' + this.getSessionDuration(s).toString().replace('.', ',') + '"' + ",";

      if (s.users || s.guest_users) {
        sessionText = sessionText + "\"";
        const sessionUsers = s.users ? Object.keys(s.users) : [];
        sessionUsers.forEach((uid, i) => {
          const user = this.users.find(u => u.id === uid);
          sessionText = sessionText + (user ? user.name : this.translateService.instant('MAIN.SESSIONS.SESSION_LIST.UNKNOWN')) + (sessionUsers.length - 1 !== i ? "," : "");
        });
        if (s.users && s.guest_users) {
          sessionText = sessionText + ",";
        }
        const guestUsers = s.guest_users ? Object.keys(s.guest_users) : [];
        guestUsers.forEach((uid, i) => {
          sessionText = sessionText + s.guest_users[uid].name + this.translateService.instant('MAIN.SESSIONS.SESSION_LIST.GUEST_LABEL') + (guestUsers.length - 1 !== i ? "," : "");
        });
        sessionText = sessionText + "\"";
      }
      exportText = exportText + sessionText + "\n";
    }
    const blob = new Blob([exportText], {type: "text/csv;charset=utf-8;"});
    const now = new Date();
    const filename = `${environment.design.appName.split(' ').join('_')}_Session_Export_${now.getFullYear()}_${("0"+(now.getMonth()+1)).slice(-2)}_${("0"+now.getDate()).slice(-2)}.csv`;
    saveAs(blob, filename);
  }

  formatDate(timestamp: number) {
    const d = new Date(timestamp+UtilityService.timezoneOffset+UtilityService.timezones[this.timezone]);
    return `${("0"+d.getDate()).slice(-2)}.${("0"+(d.getMonth()+1)).slice(-2)}.${d.getFullYear()} ${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)}:${("0" + d.getSeconds()).slice(-2)} ${this.timezone}`;
  }

  getSessionDuration(value: Session) {
    return value.start_time && value.end_time ? Math.round((value.end_time - value.start_time) / 60000 * 100) / 100 : 0;
  }

  applyFilters() {
    this.page = 1;
    if(this.filterStartEnd?.[0]) {
      this.currentStart = this.setSessionDateFilterValues(this.filterStartEnd[0], 0, 0, 0, 0);
    }
    if(this.filterStartEnd?.[1]) {
      this.currentEnd = this.setSessionDateFilterValues(this.filterStartEnd[1], 23, 59, 59, 59);
    }

    const filteringAccountBasedTimezoneStartTime = this.currentStart.getTime()-this.differenceBetweenTimezones;
    const filteringAccountBasedTimezoneEndTime = this.currentEnd.getTime()-this.differenceBetweenTimezones;

    if (this.sessionSub) { this.sessionSub.unsubscribe() }
    // Snapshot filter values for the debounced handler
    this.filterRoomsSnapshot = [...this.filterRooms];
    this.filterUsersSnapshot = [...this.filterUsers];

    this.isLoading = true;

    this.sessionSub = this.getSessions(filteringAccountBasedTimezoneStartTime, filteringAccountBasedTimezoneEndTime).subscribe(sessions => {
      if (sessions) {
        this.sessionsUpdate$.next(sessions);
      }
    });
  }

  private setupSorting(dataSource: MatTableDataSource<any>) {
    dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'room':
          return this.getRoomName(item.room_id);
        case 'create_time':
          return item.create_time;
        case 'duration':
          return this.getSessionDuration(item);
        default:
          return item[property];
      }
    };
    dataSource.sort = this.sort;
  }

  getSessions(filteringAccountBasedTimezoneStartTime, filteringAccountBasedTimezoneEndTime) {
    this.isFilterAvailable = !(!this.filterStartEnd?.[0] || !this.filterStartEnd?.[1])
    return (!this.isFilterAvailable ? this.sessionService.getSessionsAll() : this.sessionService.getSessionsIn(filteringAccountBasedTimezoneStartTime, filteringAccountBasedTimezoneEndTime)) 
  }

  async calculateStats(sessions: Session[]) {
    return new Promise(resolve => {
      const stats: any = {};
      stats.count = sessions.length;
      stats.duration = 0;
      stats.users = {};
      sessions.forEach(session => {
        const sessionDuration = session.start_time && session.end_time ? session.end_time - session.start_time : 0;
        stats.duration = stats.duration + sessionDuration;
        (session.users ? Object.keys(session.users) : []).forEach(userId => {
          if (!stats.users[userId]) {
            stats.users[userId] = {
              count: 0,
              duration: 0
            }
          }
          stats.users[userId].count = stats.users[userId].count + 1;
          stats.users[userId].duration = stats.user_durations && stats.user_durations[userId] ? stats.user_durations[userId] : 0;
        });
      });
      stats.duration = `${Math.ceil(stats.duration / 60000)} min`
      resolve(stats);
    });
  }

  ngOnDestroy() {
    if (this.accountDataSub) { this.accountDataSub.unsubscribe() }
    if (this.userSub) { this.userSub.unsubscribe() }
    if (this.sessionSub) { this.sessionSub.unsubscribe() }
    if (this.roomsSub) { this.roomsSub.unsubscribe() }
    if (this.sessionsUpdateSub) { this.sessionsUpdateSub.unsubscribe() }
  }

  prev() {
    this.page = this.page - 1;
    this.sessions = this.allSessions.slice((this.page - 1) * this.offset, this.page * this.offset);
  }

  next() {
    this.page = this.page + 1;
    this.sessions = this.allSessions.slice((this.page - 1) * this.offset, this.page * this.offset);
  }

  // onSessionDetails(session: Session) {
  //   // this.router.navigate(['/session-detail'], { 
  //   //   queryParams: { id: session.id}
  //   // })
  //   this.router.navigate(['/session-detail'],{ state: session })
  //   const [instance, onClose]  = this.detailPageService.loadComponent(SessionDetailsComponent, { session: session });
  //   instance.session = session;
    
  // }

  onSessionDetails(session: Session) {
    this.sessionDetailOpen = true
    const [instance, onClose] = this.detailPageService.loadComponent(SessionDetailsComponent);
    instance.session = session;
    instance.userSessions = false;
    onClose.then(() => {
      this.sessionDetailOpen = false;
    })
  }

  getIds(value) {
    return value ? Object.keys(value) : [];
  }

  getUserNames(userList: any) {
    return (userList ? userList.map(userId => {
      const u = this.users.find(u => u.id === userId);
      return u ? u : null;
    }) : [])
    .filter(u => u !== null)
    .sort((a, b) => {
      const nameA = a?.name?.toLocaleLowerCase() || '';
      const nameB = b?.name?.toLocaleLowerCase() || '';
      return nameA.localeCompare(nameB);
    });
  }

  getUsersName(uid) {
    const user = this.users.find(u => u.id === uid)
    if (user) {
      return user.name
    } else {
      return ""
    }
  }

  getRoomName(roomId: string) {
    const room = this.rooms.find(r => r.id === roomId);
    return room?.name || this.translateService.instant('MAIN.SESSIONS.SESSION_LIST.UNKNOWN');
  }

  showAllUsers(users) {
    const initialState= {
      userList: users
    };
    let modalRef = this.modalService.show(UserListModalComponent, {
      initialState,
      backdrop: 'static',
      class: 'modal-dialog-centered v-modal-sm',
      animated: false
    });

  }

  onGetExport(event, session) {
    event.stopPropagation();
    this.sessionService.sessionExportRequest.next([session.room_id, session.id, !!session.end_time]);
  }

}
